import React from "react";
import { type FlexProps, Flex } from "@chakra-ui/react";

export function Card({ children, ...props }: FlexProps) {
  return (
    <Flex
      border="1.5px solid"
      borderColor="base.border"
      borderRadius="md"
      direction="column"
      gap={3}
      h="100%"
      p={6}
      maxW="400px"
      mx="auto"
      w="100%"
      {...props}
    >
      {children}
    </Flex>
  );
}
